import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dancer/')({
  component: DancerSchedule,
});

function DancerSchedule() {
  return (
    <div className="space-y-8">
      <header>
        <p className="tracking-[var(--tracking-wide)] text-[var(--color-ink-muted)] text-[var(--text-sm)] uppercase">
          Your week
        </p>
        <h1 className="mt-2">Schedule</h1>
      </header>
      <p className="text-[var(--color-ink-muted)]">
        Sprint 2 wires this to your classes and rehearsals.
      </p>
    </div>
  );
}
